import { Component } from 'react'

export default class PrivacyAndPolicy extends Component {
  render() {
    return (
      <div>PrivacyAndPolicy</div>
    )
  }
}
